import { useState } from "react";
import { Outlet } from "react-router-dom";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SideBar from "./SideBar";
import Header from "./Header";
import useLogout from "./useLogout";

const WIDE = 248;
const NARROW = 76;

const readCollapsed = () => {
  try {
    return localStorage.getItem("insurance.sidebarCollapsed") === "1";
  } catch {
    return false;
  }
};

export default function AppLayout() {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("md"));
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [confirmLogout, setConfirmLogout] = useState(false);
  const logout = useLogout();

  const toggleMenu = () => {
    if (!desktop) return setMobileOpen((open) => !open);
    setCollapsed((was) => {
      try {
        localStorage.setItem("insurance.sidebarCollapsed", was ? "0" : "1");
      } catch {}
      return !was;
    });
  };
  const askLogout = () => {
    setMobileOpen(false);
    setConfirmLogout(true);
  };

  const width = collapsed ? NARROW : WIDE;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      {desktop ? (
        <Box
          component="nav"
          sx={{
            width,
            flexShrink: 0,
            position: "sticky",
            top: 0,
            height: "100vh",
            transition: "width 200ms ease",
            overflow: "hidden",
          }}
        >
          <SideBar collapsed={collapsed} onLogout={askLogout} />
        </Box>
      ) : (
        <Drawer
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: WIDE, border: 0 } }}
        >
          <SideBar onNavigate={() => setMobileOpen(false)} onLogout={askLogout} />
        </Drawer>
      )}

      <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <Header onMenuClick={toggleMenu} onLogout={askLogout} />
        <Box
          component="main"
          sx={{
            flex: 1,
            px: { xs: 2, md: 4 },
            py: { xs: 2.5, md: 3.5 },
            width: "100%",
            maxWidth: 1600,
            mx: "auto",
          }}
        >
          <Outlet />
        </Box>
        <Typography
          component="footer"
          variant="caption"
          color="text.secondary"
          sx={{ textAlign: "center", py: 2 }}
        >
          Powered by Rosoftsavvy © {new Date().getFullYear()}
        </Typography>
      </Box>

      <Dialog open={confirmLogout} onClose={() => setConfirmLogout(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Log out?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You will also be logged out of the other bank apps in this browser.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button onClick={() => setConfirmLogout(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setConfirmLogout(false);
              logout();
            }}
          >
            Log out
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
